import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=e9ef13a0&"
import script from "./QA.vue?vue&type=script&lang=js&"
export * from "./QA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports